import { defineMessages } from 'react-intl'

export default defineMessages({
  createModalTitle: {
    id: 'CreateLegalEntityFormPresenter.createModalTitle',
    defaultMessage: 'Create new entity',
  },
  inboxHandleTakenError: {
    id: 'CreateLegalEntityFormPresenter.inboxHandleTakenError',
    defaultMessage: 'This inbox name is taken. Try a different one.',
  },
  inboxHandleTakenToast: {
    id: 'CreateLegalEntityFormPresenter.inboxHandleTakenToast',
    defaultMessage:
      'This inbox name is taken. Select Edit to choose a different one.',
  },
  errorToastTitle: {
    id: 'CreateLegalEntityFormPresenter.errorToastTitle',
    defaultMessage: 'Could not create entity',
  },
})
